import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { PagingAndOrderingModel } from '../common/PagingAndOrdering.model';

export class ChatFilter extends PagingAndOrderingModel {
    public vesselVisitId: number;
    public storageDocumentId: number;
    public amendmentDocumentId: number;
    public serviceRequestId: number;

    constructor(pageFilter?: PagingAndOrderingModel, data = null) {
        super();

        if (data) {
            Object.assign(this, data);
        }
    }

    createFormGroup() {
        const form = new UntypedFormGroup({
            serviceRequestId: new UntypedFormControl({ value: null, disabled: false }),
            vesselVisitId: new UntypedFormControl({ value: null, disabled: false }),
            storageDocumentId: new UntypedFormControl({ value: null, disabled: false }),
            amendmentDocumentId: new UntypedFormControl({ value: null, disabled: false })
        });

        form.patchValue(this);
        return form;
    }
}
